<template>
  <form enctype="multipart/form-data" class="subscribe-form">
    <input type="hidden" name="TYPE_FORM" value="subscribe">
    <input type="hidden" name="Theme" :value="themeValue">
    <input type="hidden" name="PORTFOLIO" value="Creative Commerce">

    <div class="subscribe-form__value">
      <input type="email" name="Email" placeholder="E-mail" class="subscribe-form__input input-email">

      <button type="submit" class="button button_white">
        Subscribe
        <IconArrow/>
      </button>
    </div>

    <div class="subscribe-form__agree">
      <div class="checkbox-input">
        <input type="checkbox" name="AGREEMENT" :id="checkboxId" class="checkbox">
        <label :for="checkboxId">
          I want to receive exclusive content from Creative&nbsp;Commerce: insider guides and personalized tips for my store.
        </label>
      </div>
    </div>

  </form>
</template>

<script setup>
import { onMounted, computed } from 'vue'
import JustValidate from 'just-validate'
import IconArrow from '@/components/icons/IconArrow.vue'

const props = defineProps({
  theme: {
    type: String,
    default: ''
  },
  id: {
    type: Number,
    default: 0
  }
})

const themeValue = computed(() => props.theme ? props.theme : 'None')
const checkboxId = computed(() => `subscribe-agree-${props.id}`)

onMounted(() => {
  const forms = document.querySelectorAll('.subscribe-form')

  forms.forEach((form, index) => {
    const emailInput = form.querySelector('.input-email')
    const checkbox = form.querySelector('.checkbox')

    if (!emailInput || !checkbox) return

    let msgEl = form.querySelector('.subscribe-msg')
    if (!msgEl) {
      msgEl = document.createElement('div')
      msgEl.className = 'subscribe-msg'
      form.appendChild(msgEl)
    }

    const validation = new JustValidate(form)

    validation
        .addField(emailInput, [
          { rule: 'required', value: true, errorMessage: 'Please enter your email' },
          { rule: 'email', value: true, errorMessage: 'Email format is invalid' }
        ])
        .addField(checkbox, [
          { rule: 'required', value: true, errorMessage: 'You must agree to Terms & Privacy Policy' }
        ])
        .onSuccess((event) => {
          let formData = new FormData(event.target)
          let xhr = new XMLHttpRequest()

          form.classList.add('loading')

          xhr.onreadystatechange = function () {
            if (xhr.readyState === 4) {
              if (xhr.status === 200) {
                msgEl.textContent = 'Thank you for subscribing!'
                event.target.reset()
              } else {
                msgEl.textContent = 'Something went wrong. Please try again.'
              }
              form.classList.remove('loading')
            }
          }

          xhr.open('POST', 'https://creativecommercelabs.com/zendesk/subscribe.php', true)
          xhr.send(formData)
        })
  })
})
</script>

<style lang="scss">
.subscribe-form {
  &__value {
    display:flex;
    gap:10px;
    position:relative;

    .just-validate-error-label {
      top:100%;
      left:0;
      position:absolute;
      font-size:12px;
      padding:4px 0 0;
      display:none;

      &:nth-of-type(1) {
        display:block;
      }
    }

    @include xs {
      flex-direction:column;
    }
  }

  &__input {
    height:3.5rem;
    padding:0 1rem;
    border-radius:1rem;
    background: rgba(245, 245, 245, 0.08);
    font-weight:500;
    border: 1px solid rgba(245, 245, 245, 0.2);
    color:#fff;
    font-size:1rem;
    transition:var(--transition);
    width:100%;
    box-sizing:border-box;
    font-family:var(--font-family);
    outline:none;

    @include md {
      height:3rem;
    }

    &:focus {
      border: 1px solid rgba(245, 245, 245, 0.3);
      background: rgba(245, 245, 245, 0.15);
    }

    &::placeholder {
      color:#b2b2b2;
    }
  }

  &__agree {
    margin:1.5rem 0 0;
    position:relative;

    .just-validate-error-label {
      top:100%;
      left:0;
      position:absolute;
      font-size:12px;
      padding:4px 0 0;
      display:none;

      &:nth-of-type(1) {
        display:block;
      }
    }

    @include md {
      margin-top:1rem;
    }
  }

  .button {
    flex:none;
    height:3.5rem;

    @include md {
      width:initial;
    }
  }

  .subscribe-msg {
    margin-top: 1rem;
    color: #fff;
    font-weight: 500;
  }
}
</style>
